import { useNavigate } from 'react-router-dom';
import useCreate from '../useCreate';
import toast from 'react-hot-toast';

const useCreateUpdateCertificate = ({ reset }) => {
  const navigate = useNavigate();

  const { setDataToServer } = useCreate({
    url: 'certificate/create_update',
    refreshUrl: 'certificate/list',
    onSuccess: () => {
      reset?.();
      toast.success("Certificate Saved Successfully", {
        position: "top-right",
        duration: 3000
      });
      navigate('/masters/certificates');
    }
  });

  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return { handleSubmit };
};

export default useCreateUpdateCertificate;
